import styles from "./slider.module.css"
export const SLIDES = [
    // {
    //     className: styles.slide6,
    //     description: "crypto_buying_selling_available",
    //     additionalDescription: "please_note_some_rare",
    //     components: {
    //         br: <br />,
    //     },
    //     buttonClassName: styles.button,
    //     buttonText: "sign_up",
    // },
    {
        className: styles.slide1,
        title: "banking",
        description: "payment_account_with",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
    {
        className: styles.slide2,
        title: "spend_globally_pay_locally",
        description: "no_monthly_fees",
        components: {
            br: <br />,
        },
        values: { price:"£10" },
        caption: "availability_dependent_on_jurisdiction",
        additionalDescription: "just_price_to_issue",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
    {
        className: styles.slide4,
        title: "iban",
        description: "get_dedicated_iban",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
]

export const LEGACY_SLIDES = [
    {
        className: styles.slide1,
        title: "banking",
        description: "payment_account_with",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
    {
        className: styles.slide2,
        title: "spend_globally_pay_locally",
        description: "no_monthly_fees",
        components: {
            br: <br />,
        },
        values: { price:"£10" },
        caption: "availability_dependent_on_jurisdiction",
        additionalDescription: "just_price_to_issue",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
    {
        className: styles.slide3,
        title: "crypto",
        description: "crypto_wallet_with_over",
        caption: "service_may_vary_by",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
    {
        className: styles.slide4,
        title: "iban",
        description: "get_dedicated_iban",
        buttonClassName: styles.button,
        buttonText: "sign_up",
    },
]
